import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginRequestDto } from '../dtos/login-request.dto';

export class AuthenticationFormFactory {
  static createLoginForm(fb: FormBuilder): FormGroup {
    return fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  static createSetPasswordForm(fb: FormBuilder): FormGroup {
    return fb.group({
      verificationCode: ['', Validators.required],
      password: ['', Validators.required],
      passwordRepeat: ['', Validators.required]
    });
  }
}
